import { render, staticRenderFns } from "./AccountAddress.vue?vue&type=template&id=4aaf693d"
import script from "./AccountAddress.vue?vue&type=script&lang=js"
export * from "./AccountAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports